import React, { useCallback } from 'react'

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, SvgIcon, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@scoir/tooltips'
import Select from 'material/Select'
import PropTypes from 'prop-types'

import { getSegmentOperation, getSegmentValue } from 'components/SegmentSelector/segment-service'

import { withContext } from '../Context'
import { OPTIONS, OPTIONS_ARRAY, getAppropriateOption } from './service'

export const SegmentName = 'FirstGeneration'

const useStyles = makeStyles(() => ({
  infoIcon: {
    fontSize: '18px',
    alignSelf: 'center',
  },
}))

export const FirstGenSelector = ({ criteria, segment, onChange }) => {
  const classes = useStyles()

  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const currentOperation = getSegmentOperation(segment, criteria, SegmentName)
  const valueStr = getAppropriateOption(currentValue, currentOperation)
  const change = useCallback(
    (valueStr) => {
      const { Values, Operation } = OPTIONS[valueStr]
      onChange(criteria, SegmentName, Values, Operation)
    },
    [criteria, onChange],
  )
  return (
    <>
      <Box
        pt={4}
        display="flex"
        justifyContent="space-between"
      >
        <Box>
          <Typography
            variant="subtitle2"
            color="textPrimary"
            className="title"
          >
            First Generation Students
          </Typography>
        </Box>
        <Tooltip
          title="A First Generation Student is student that neither parent or guardian has received a 4-year college degree."
          placement="top"
        >
          <SvgIcon
            color="primary"
            className={classes.infoIcon}
          >
            <FontAwesomeIcon
              icon={faInfoCircle}
              size="xs"
            />
          </SvgIcon>
        </Tooltip>
      </Box>
      <Select
        id="segmentation-first-gen-selector"
        label="Student Status"
        value={valueStr}
        options={OPTIONS_ARRAY}
        onChange={change}
      />
    </>
  )
}

FirstGenSelector.propTypes = {
  criteria: PropTypes.string.isRequired,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

FirstGenSelector.defaultProps = {
  criteria: 'Must',
}

export default withContext(FirstGenSelector)
